<my-content placeholder="navigation">

    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading">{{ModelFor}}</h4><br>
                    <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]('')" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="700px" frameBorder="0" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>

    @if (true) {
        <div class="container-fluid">
            <div class="table-header-container">
                <div class="table-heading">
                View Expense Details
                </div>
                <form #SearchExpense="ngForm" [formGroup]="FormSearchExpense" (ngSubmit)="onSearchExpense(SearchExpense.value)">
                <div class="d-flex">
                    <div class="input-group">
                    <input type="text" placeholder="Search here" class="table-search-input form-control" formControlName="txtSearch">
                    <span class="input-group-btn">
                        <button class="btn btn-primary" title="Search" type="submit">
                        Go
                        </button>
                    </span>
                    </div>
                    @if (this.RightsID.includes('202026001') || this.RightsID.includes('202026021')) {
                    <button class="btn btn-outline-primary mx-2" title="Add New Expense" data-toggle="modal" 
                        (click)="OpenModal('expense','0','Add Expense','ReturnAdvanceSearch','0')" data-target="#ModalPopUP">
                        <i class="fas fa-plus"></i>
                    </button>
                    } @else {
                    <button class="btn btn-outline-primary mx-2" title="Add New Expense" routerLink="/module/0">
                        <i class="fas fa-plus"></i>
                    </button>
                    }
                    <button class="btn btn-outline-primary" title="Advance Search" data-toggle="modal" 
                    (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch','0')" data-target="#ModalPopUP">
                    <i class="fas fa-filter"></i>
                    </button>
                    <!-- <div class="mr-4"> -->
                    <a class="btn btn-outline-primary mx-2" routerLink="/report/207086000" title="Approve Listing">
                    Approved Listing <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    </a>
                    <!-- </div> -->
                    <!-- <div class="mr-4"> -->
                        <a class="btn btn-outline-primary" routerLink="/report/207087000" title="Reject Listing">
                        Rejected Listing <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                    <!-- </div> -->
                </div>
                </form>
            </div>
            @if (selectedAmount > 0) {
                <div class="row">
                    <h4 class="ms-3" >Total Amount: {{selectedAmount}}</h4>
                </div>
            }
            <div class="card table-container">
                <table class="custom-table">
                <thead>
                    <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Ref No.</th>
                    <th>User</th>
                    <th>Nature of Expense</th>
                    <th>Description</th>
                    <th>Total</th>
                    <th>Action</th>
                    <th> <input  [(ngModel)]="allSelected" (click)="selectAll()"  type="checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <app-table-state
                    [loading]="MsgType == 1"
                    [error]="MsgType == 3 ? DisplayMessage : null"
                    [empty]="filteredData?.length == 0"
                    [rows]="10"
                    [columns]="9">
                    </app-table-state>
                    @if ( filteredData?.length > 0) {
                        @for (expenseDetailData of filteredData | paginate : { itemsPerPage: 10, currentPage: pageNumber }; track expenseDetailData.id ?? i ; let i = $index) {
                        <tr>
                            <td align="center">{{ (pageNumber - 1) * 10 + i + 1 }}</td>
                            <td>{{ expenseDetailData.Date | date: "dd-MMM-yyyy" }}</td>
                            <td>
                            <a target="_blank" routerLink="/gnotice/{{ expenseDetailData.type }}/{{ expenseDetailData.NoticeID }}">
                                {{ expenseDetailData.refno }}
                            </a>
                            </td>
                            <td>{{ expenseDetailData.UserName }}</td>
                            <td>{{ expenseDetailData.MainDescr }}</td>
                            <td>{{ expenseDetailData.Description }}</td>
                            <td>{{ expenseDetailData.UnitRate }}</td>
                            <td>
                            <div class="d-flex">
                                @if (this.RightsID.includes('202026001') || this.RightsID.includes('202026021')) {
                                <button class="icon-btn icon-btn-primary text-decoration-none mr-2" data-toggle="modal" 
                                    (click)="OpenModal('expense',expenseDetailData.ID,'Edit Expense','ReturnAdvanceSearch',expenseDetailData.NoticeID)" 
                                    data-target="#ModalPopUP">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                                } @else {
                                <button class="icon-btn icon-btn-primary text-decoration-none mr-2" routerLink="/module/0">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                                }
                                @if (this.RightsID.includes('202026021') && expenseDetailData.approvestatus == '0') {
                                <a class="icon-btn icon-btn-danger text-decoration-none" title="Delete" (click)="DeleteExpense(expenseDetailData.ID)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </a>
                                }
                            </div>
                            </td>
                            <td>
                                <input (change)="onChangeSelection()"  [(ngModel)]="expenseDetailData.isSelected" value="{{ expenseDetailData.ID }}" type="checkbox">
                            </td>
                        </tr>
                        }
                    }
                </tbody>
                </table>
            </div>
            @if (filteredData?.length > 0) {
                <div class="d-flex justify-content-between my-3 w-100">
                    <div class="w-50">
                        <app-rows-per-page
                        [pageSize]="pageSize"
                        [total]="totalRecords"
                        [pageIndex]="pageNumber"
                        (pageSizeChange)="onPageSizeChange($event)">
                    </app-rows-per-page>
                    </div>
                    <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
                </div>
            }
            <div class="row mt-3">
                <div class="col-sm-12 d-flex justify-content-center">
                @if (expenseCount == '1' && filteredData?.length > 0) {
                    <div class="mr-2">
                    <button class="btn btn-primary" (click)="Approveexpense()">Approve</button>
                    </div>
                    <div>
                    <button class="btn btn-danger" (click)="Rejectexpense()">Reject</button>
                    </div>
                }
                </div>
            </div>
        </div>
    } @else {
        <!-- <div class="col-sm-12" style="margin-top: 8px;">
            <div class="col-sm-12" style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
                <div class="col-sm-4">
                    <form #SearchExpense="ngForm" [formGroup]="FormSearchExpense" (ngSubmit)="onSearchExpense(SearchExpense.value);">
                        <div class="col-sm-2 text-left height-34">Search</div>
                        <div class="col-sm-6"><input class="form-control" formControlName="txtSearch" placeholder="Search here" name="txtSearch" type="text" value=""></div>
                        <div class="col-sm-2"><input class="btn btn-primary btn-sm-12" type="submit" value="Go"></div>
                        <div class="col-sm-2"> <a title="Advance Search" data-toggle="modal" (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch','0');" data-target="#ModalPopUP"><i _ngcontent-efg-c1="" class="material-icons"> filter_list </i></a>
                        </div>
                    </form>
                </div>
    
                <div class="col-sm-4">&nbsp;</div>
                <div class="col-sm-4 d-flex"  style="justify-content:right;">
                    <div class="col-sm-8"> &nbsp;</div>
                    <div class="col-sm-4 height-34">
                        <div class="form-group col-sm-6" *ngIf="this.RightsID.includes('202026001') || this.RightsID.includes('202026021') ; then ADDExpenseLink else AddExpenseNotLink"></div>
                        <ng-template #ADDExpenseLink>
                            <a href="#" data-toggle="modal" (click)="OpenModal('expense','0','Add Expense','ReturnAdvanceSearch','0');" data-target="#ModalPopUP">Add New Expense</a>
                        </ng-template>
                        <ng-template #AddExpenseNotLink>
                            <a href="module/0">Add New Expense</a>
                        </ng-template>
                    </div>
                    <div class="col-sm-4 height-34">
                       
                        <a href="#/report/207086000" data-toggle="modal">Approve Listing</a>
                    </div>
                    <div class="col-sm-4 height-34">
                       
                        <a href="#/report/207087000" data-toggle="modal">Reject Listing</a>
                    </div>
                </div>
    
            </div>
        </div>
    
        <div class=" col-sm-12">
            <div class="col-sm-12 lefticonD paddingless tableHeading">View Expense Details</div>
            <table width="100%" class="LMtable">
                <tr>
                    <th>S.No.</th>
                    <th>Date</th>
                    <th>Ref No.</th>
                    <th>User</th>
                    <th>Nature of Expense</th>
                    <th>Description</th>
                    <th>Total</th>
                    <th>Action</th>
                    <th>Status</th>
                </tr>
    
                <tr *ngIf="this.MsgType == 1">
                    <td colspan="80">
                        <div class="d-flex align-items-center">
                            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 2">
                    <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                        <span>{{DisplayMessage}}</span>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 3">
                    <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                    </td>
                </tr>
                <ng-container *ngIf="this.MsgType == 0">
                    <tr *ngFor="let expenseDetailData of expenseDetail | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index">
                        <td>{{(pageNumber - 1) * 10 + i +1 }}</td>
                        <td>{{expenseDetailData.Date|date:'dd-MMM-yyyy'}}</td>
                        <td> <a target="_blank" routerLink="/gnotice/{{expenseDetailData.type}}/{{expenseDetailData.NoticeID}}">{{expenseDetailData.refno}}</a></td>
                        <td>{{expenseDetailData.UserName}}</td>
                        <td>{{expenseDetailData.MainDescr}}</td>
                        <td>{{expenseDetailData.Description}}</td>
                        <td>{{expenseDetailData.Value}}</td>
                        <td>
                            <div class="form-group col-sm-6" *ngIf="this.RightsID.includes('202026001') || this.RightsID.includes('202026021') ; then EditExpenseLink else EditExpense"></div>
                            <ng-template #EditExpenseLink>
                                <a data-toggle="modal" (click)="OpenModal('expense',expenseDetailData.ID,'Edit Expense','ReturnAdvanceSearch',expenseDetailData.NoticeID);" data-target="#ModalPopUP">
                                    <i class="fa fa-pencil font-16 theme-icon"></i>
                                 </a>
                            </ng-template>
                            <ng-template #EditExpense>
                                <a href="module/0">
                                    <i class="fa fa-pencil font-16 theme-icon"></i>
                                </a>
                            </ng-template>
    
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <div class="form-group col-sm-6" *ngIf="this.RightsID.includes('202026021') && expenseDetailData.approvestatus=='0' ; then DeleteExpenseLink else DeleteExpenseNotLink"></div>
                            <ng-template #DeleteExpenseLink>
                                <a title="Delete" (click)="DeleteExpense(expenseDetailData.ID) ">
                                    <i class="fa fa-trash font-16 text-danger cursor-pointer"></i>
                                </a>
                            </ng-template>
                            <ng-template #DeleteExpenseNotLink>
                               &nbsp;
                            </ng-template>
    
                        </td>
                        <td>
                            <input [(ngModel)]="expenseDetailData.isSelected"  value="{{expenseDetailData.ID}}" type="checkbox">
                         </td>
                    </tr>
                </ng-container>
            </table><br>
            <ng-container *ngIf="this.MsgType == 0">
                <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
            </ng-container>
        </div>
    
        <div class="d-flex justify-content-center w-100 ">
            <ng-container *ngIf="this.expenseCount=='1'">
                <button class="btn btn-primary mr-4" (click)="Approveexpense()" >Approve</button>
                <button class="btn btn-danger" (click)="Rejectexpense()" >Reject</button>
            </ng-container>
        </div> -->
    }
</my-content>
<my-content placeholder="main">

</my-content>